import { message } from '../../../Reducers/loading/actions';

// Action Types
export const FACILITY_STORINGEN_LOADING = 'FACILITY_STORINGEN_LOADING';
export const FACILITY_STORINGEN_SUCCESS = 'FACILITY_STORINGEN_SUCCESS';
export const FACILITY_STORINGEN_ERROR = 'FACILITY_STORINGEN_ERROR';

export const FACILITY_STORING_DETAIL_SUCCESS = 'FACILITY_STORING_DETAIL_SUCCESS';
export const FACILITY_STORING_CREATE_SUCCESS = 'FACILITY_STORING_CREATE_SUCCESS';
export const FACILITY_STORING_UPDATE_SUCCESS = 'FACILITY_STORING_UPDATE_SUCCESS';

export const FACILITY_ACCOMMODATIES_SUCCESS = 'FACILITY_ACCOMMODATIES_SUCCESS';
export const FACILITY_ACCOMMODATIE_DETAIL_SUCCESS = 'FACILITY_ACCOMMODATIE_DETAIL_SUCCESS';

export const FACILITY_WERKORDERS_SUCCESS = 'FACILITY_WERKORDERS_SUCCESS';
export const FACILITY_WERKORDER_DETAIL_SUCCESS = 'FACILITY_WERKORDER_DETAIL_SUCCESS';

export const FACILITY_CATEGORIES_SUCCESS = 'FACILITY_CATEGORIES_SUCCESS';
export const FACILITY_EXISTING_ACCOMMODATIES_SUCCESS = 'FACILITY_EXISTING_ACCOMMODATIES_SUCCESS';
export const FACILITY_EXISTING_KAMPEERPLAATSEN_SUCCESS = 'FACILITY_EXISTING_KAMPEERPLAATSEN_SUCCESS';

export const FACILITY_DASHBOARD_SUCCESS = 'FACILITY_DASHBOARD_SUCCESS';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token
  };
};

// Helper function to handle fetch responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

// STORINGEN ACTIONS
export const fetchStoringen = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: FACILITY_STORINGEN_LOADING });
    
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(`/api/facility/storingen?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORINGEN_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching storingen:', error);
      dispatch({
        type: FACILITY_STORINGEN_ERROR,
        payload: error.message || 'Error fetching storingen'
      });
      dispatch(message('Error loading storingen'));
      throw error;
    }
  };
};

export const fetchStoringById = (id) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/storingen/${id}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORING_DETAIL_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching storing:', error);
      dispatch(message('Error loading storing details'));
      throw error;
    }
  };
};

export const createStoring = (formDataOrObject) => {
  return async (dispatch) => {
    try {
      let body;
      let headers = {
        'Authorization': localStorage.getItem('token')
      };

      // Check if it's already FormData (from form) or needs to be converted
      if (formDataOrObject instanceof FormData) {
        body = formDataOrObject;
      } else {
        // Convert object to FormData
        const formData = new FormData();
        
        Object.keys(formDataOrObject).forEach(key => {
          if (formDataOrObject[key] !== null && formDataOrObject[key] !== undefined && formDataOrObject[key] !== '') {
            if (key === 'fotos' && Array.isArray(formDataOrObject[key])) {
              // Handle file array
              formDataOrObject[key].forEach(file => {
                formData.append('fotos', file);
              });
            } else {
              formData.append(key, formDataOrObject[key]);
            }
          }
        });
        
        body = formData;
      }
      
      const response = await fetch('/api/facility/storingen', {
        method: 'POST',
        headers,
        body
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORING_CREATE_SUCCESS,
        payload: data
      });
      
      dispatch(message(3000, 'Storing succesvol aangemaakt'));
      return data;
    } catch (error) {
      console.error('Error creating storing:', error);
      dispatch(message(error.message || 'Error creating storing'));
      throw error;
    }
  };
};

export const updateStoring = (id, updateData) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/storingen/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(updateData)
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORING_UPDATE_SUCCESS,
        payload: data
      });
      
      dispatch(message(3000, 'Storing succesvol bijgewerkt'));
      return data;
    } catch (error) {
      console.error('Error updating storing:', error);
      dispatch(message(error.message || 'Error updating storing'));
      throw error;
    }
  };
};

export const updateStoringStatus = (id, status, comment = '') => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/storingen/${id}/status`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify({ status, comment })
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORING_UPDATE_SUCCESS,
        payload: data
      });
      
      dispatch(message(3000, 'Status succesvol bijgewerkt'));
      return data;
    } catch (error) {
      console.error('Error updating storing status:', error);
      dispatch(message(error.message || 'Error updating status'));
      throw error;
    }
  };
};

export const assignStoring = (id, toegewezenAan, comment = '') => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/storingen/${id}/assign`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify({ toegewezenAan, comment })
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORING_UPDATE_SUCCESS,
        payload: data
      });
      
      dispatch(message(3000, 'Storing succesvol toegewezen'));
      return data;
    } catch (error) {
      console.error('Error assigning storing:', error);
      dispatch(message(error.message || 'Error assigning storing'));
      throw error;
    }
  };
};

export const addNotitieToStoring = (id, tekst, intern = false) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/storingen/${id}/notities`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ tekst, intern })
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_STORING_UPDATE_SUCCESS,
        payload: data
      });
      
      dispatch(message(3000, 'Notitie toegevoegd'));
      return data;
    } catch (error) {
      console.error('Error adding notitie:', error);
      dispatch(message(error.message || 'Error adding notitie'));
      throw error;
    }
  };
};

// ACCOMMODATIES ACTIONS
export const fetchAccommodaties = (filters = {}) => {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(`/api/facility/accommodaties?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_ACCOMMODATIES_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching accommodaties:', error);
      dispatch(message('Error loading accommodaties'));
      throw error;
    }
  };
};

export const fetchAccommodatieById = (id) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/accommodaties/${id}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_ACCOMMODATIE_DETAIL_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching accommodatie:', error);
      dispatch(message('Error loading accommodatie details'));
      throw error;
    }
  };
};

export const createAccommodatie = (accommodatieData) => {
  return async (dispatch) => {
    try {
      const response = await fetch('/api/facility/accommodaties', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(accommodatieData)
      });
      
      const data = await handleResponse(response);
      
      dispatch(message(3000, 'Accommodatie succesvol aangemaakt'));
      return data;
    } catch (error) {
      console.error('Error creating accommodatie:', error);
      dispatch(message(error.message || 'Error creating accommodatie'));
      throw error;
    }
  };
};

// WERKORDERS ACTIONS
export const fetchWerkorders = (filters = {}) => {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(`/api/facility/werkorders?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_WERKORDERS_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching werkorders:', error);
      dispatch(message('Error loading werkorders'));
      throw error;
    }
  };
};

export const fetchWerkorderById = (id) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/werkorders/${id}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_WERKORDER_DETAIL_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching werkorder:', error);
      dispatch(message('Error loading werkorder details'));
      throw error;
    }
  };
};

export const fetchKanbanData = (filters = {}) => {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams(filters);
      const response = await fetch(`/api/facility/werkorders/kanban?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      return data;
    } catch (error) {
      console.error('Error fetching kanban data:', error);
      dispatch(message('Error loading kanban data'));
      throw error;
    }
  };
};

// CATEGORIES ACTIONS
export const fetchCategories = (hierarchical = false) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/facility/categories?hierarchical=${hierarchical}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_CATEGORIES_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      dispatch(message('Error loading categories'));
      throw error;
    }
  };
};

export const createCategory = (categoryData) => {
  return async (dispatch) => {
    try {
      const response = await fetch('/api/facility/categories', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(categoryData)
      });
      
      const data = await handleResponse(response);
      
      dispatch(message(3000, 'Categorie succesvol aangemaakt'));
      return data;
    } catch (error) {
      console.error('Error creating category:', error);
      dispatch(message(error.message || 'Error creating category'));
      throw error;
    }
  };
};

export const seedDefaultCategories = () => {
  return async (dispatch) => {
    try {
      const response = await fetch('/api/facility/categories/seed', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({})
      });
      
      const data = await handleResponse(response);
      
      dispatch(message(3000, 'Standaard categorieën succesvol aangemaakt'));
      return data;
    } catch (error) {
      console.error('Error seeding categories:', error);
      dispatch(message(error.message || 'Error seeding categories'));
      throw error;
    }
  };
};

// DASHBOARD ACTIONS
export const fetchStoringenDashboard = () => {
  return async (dispatch) => {
    try {
      const response = await fetch('/api/facility/storingen/dashboard', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_DASHBOARD_SUCCESS,
        payload: data
      });
      
      return data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      dispatch(message('Error loading dashboard data'));
      throw error;
    }
  };
};

export const fetchAccommodatiesDashboard = () => {
  return async (dispatch) => {
    try {
      const response = await fetch('/api/facility/accommodaties/dashboard', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      return data;
    } catch (error) {
      console.error('Error fetching accommodaties dashboard:', error);
      dispatch(message('Error loading accommodaties dashboard'));
      throw error;
    }
  };
};

export const fetchWerkordersDashboard = () => {
  return async (dispatch) => {
    try {
      const response = await fetch('/api/facility/werkorders/dashboard', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      return data;
    } catch (error) {
      console.error('Error fetching werkorders dashboard:', error);
      dispatch(message('Error loading werkorders dashboard'));
      throw error;
    }
  };
};

// EXISTING COLLECTIONS ACTIONS
export const fetchExistingAccommodaties = (search = '') => {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams({ search, limit: 100 });
      const response = await fetch(`/api/facility/accommodaties-lijst?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_EXISTING_ACCOMMODATIES_SUCCESS,
        payload: data.results || []
      });
      
      return data.results || [];
    } catch (error) {
      console.error('Error fetching existing accommodaties:', error);
      dispatch(message('Error loading accommodaties'));
      throw error;
    }
  };
};

export const fetchExistingKampeerplaatsen = (search = '') => {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams({ search, limit: 100 });
      const response = await fetch(`/api/facility/kampeerplaatsen-lijst?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FACILITY_EXISTING_KAMPEERPLAATSEN_SUCCESS,
        payload: data.results || []
      });
      
      return data.results || [];
    } catch (error) {
      console.error('Error fetching existing kampeerplaatsen:', error);
      dispatch(message('Error loading kampeerplaatsen'));
      throw error;
    }
  };
};

